<template>
    <div>
        <v-card class="rounded-lg shadow" :loading="isLoading" :disabled="isLoading" elevation="0">
            <v-card-text class="p-3">

                <v-skeleton-loader v-if="isLoading" type="table" />

                <div v-else>
                    <div class="d-flex justify-space-between mb-2">
                        <div>

                        </div>
                        <div class="d-flex justify-space-between ">
                            <v-text-field v-model="filter.keyword" rounded filled dense style="width: 300px"
                                append-icon="mdi-magnify" single-line hide-details clearable placeholder="Rechercher..."
                                v-on:keyup.enter="getItems" />

                            <v-btn rounded color="primary" class="ml-1" elevation="0" @click="addModel">Ajouter</v-btn>
                        </div>
                    </div>

                    <v-divider />

                    <v-simple-table elevation="0">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Icone</th>
                                    <th>Nom</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in models" :key="item.id">
                                    <td>
                                        {{ item.id }}
                                    </td>
                                    <td style="max-width: 50px">
                                        <v-img :src="getImageLink(item.image)" max-height="40" contain class="mt-2"
                                            v-if="item.image != null"></v-img>
                                    </td>
                                    <td>
                                        {{ item.name }}
                                    </td>
                                    <td>

                                        <v-menu transition="slide-x-transition" bottom right>

                                            <v-list dense>

                                                <v-list-item @click="updateModel(item)">
                                                    <v-list-item-icon>
                                                        <v-icon color="black">mdi-pencil</v-icon>
                                                    </v-list-item-icon>
                                                    <v-list-item-title>Modifier</v-list-item-title>
                                                </v-list-item>
                                                <v-list-item @click="deleteModel(item)">
                                                    <v-list-item-icon>
                                                        <v-icon color="red">mdi-delete</v-icon>
                                                    </v-list-item-icon>
                                                    <v-list-item-title>Supprimer</v-list-item-title>
                                                </v-list-item>

                                            </v-list>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn color="black" icon dark v-bind="attrs" v-on="on">
                                                    <v-icon>mdi-dots-vertical</v-icon>
                                                </v-btn>
                                            </template>


                                        </v-menu>

                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>

                </div>

            </v-card-text>
        </v-card>
        <AddModelDialog ref="addModele" @refresh="getItems"/>
        <UpdateModelDialog ref="updateModele" @refresh="getItems"/>
        <ConfirmDelete ref="confirmDelete" @confirmed="removeModel"/>
    </div>
</template>

<script>


import { HTTP } from "@/http-common";

import AddModelDialog from "./components/AddModelDialog.vue";
import UpdateModelDialog from "./components/UpdateModelDialog.vue";
import ConfirmDelete from "./components/ConfirmDelete.vue";

export default {
    components: { AddModelDialog, UpdateModelDialog, ConfirmDelete},
    data() {
        return {
            delete_id: null,
            filter: {
                keyword: ""
            }
        }
    },
    methods: {
        getItems() {
            this.$store.dispatch("fetchEcommerceModels", {
                filter: this.filter
            });
        },
        addModel() {
            this.$refs.addModele.open();
        },
        updateModel(item) {
            this.$refs.updateModele.open(item);
        },
        deleteModel(item) {
            this.delete_id = item.id;
            this.$refs.confirmDelete.open();

        },
        removeModel(){
            HTTP.delete("v1/ecommerce/models/"+this.delete_id)
                .then(() => {
                    this.$successMessage = "Un Modèle du E-commerce a été supprimé";
                    this.getItems()
                })
                .catch((err) => {
                    console.log(err);
                });
        }

    },
    computed: {
        isLoading() {
            return this.$store.getters.ecommerceModelsLoading;
        },
        models() {
            return this.$store.getters.getEcommerceModels;
        }
    }
}
</script>